import { FieldGroupsType, FormServFieldType } from '../shared/types';

export const SURVEY_LIMIT = 20;
export const SURVEY_BLOCKS_LIMIT = 20;
export const ACTIVE_SURVEY_LIMIT = 3;
export const WORKFLOW_LIMIT = 30;
export const USER_LIMIT = 10;
export const SURVEY_COLLECTOR_LIMIT = 10;
export const CONTACT_LIMIT = 10000;
export const CONTACT_LISTS_LIMIT = 20;
export const CONTACTS_IMPORT_LIMIT = 10000;
export const SEGMENTS_LIMIT = 20;
export const SAVED_TEMPLATES_LIMIT = 25;

export const GLOBAL_PER_PAGE = 20;
export const COTACTS_PER_PAGE = 50;
export const TEMPLATES_PER_PAGE = 25;
export const DISABLE_EXPORT_DURATION_IN_MS = 10 * 60 * 1000;
export const MIN_SEARCH_LIMIT = 2;

export const HIGHLIGHT_COLUMNS: string[] = ['label', 'name'];

export const ON_CLICK_OPEN_COLUMNS: string[] = ['first_name', 'last_name'];

// https://confluence.freshworks.com/pages/viewpage.action?pageId=302110398

export const MCR_DEFAULT_FIELDS: string[] = [
  'id',
  'account_id',
  'created_by_product',
  'updated_by_product',
  'system_created_at',
  'system_updated_at',
  'merged_to',
  'version',
  'merged_from',
  'modified_by',
  'source',
  'id_str',
  'status',
  'created_at',
  'updated_at',
  'creater_id',
  'updater_id',
  'persona',
  'primary_email',
  'primary_company_name',
  'sub_state',
  'mobile_number',
  'external_id',
  'visitor_id',
  'twitter',
  'first_name',
  'last_name',
  'work_email',
  'work_number',
  'city',
  'address',
  'state',
  'country',
  'zipcode',
  'last_seen',
  'emails',
  'phone_numbers',
  'mcr_company_ids',
];

export const fieldGroups: Array<FieldGroupsType> = [
  {
    id: 'basicFields',
    name: 'contacts.field_group.basic_contact_fields',
    filter: (field: FormServFieldType) => !!field.field_options?.fs_default,
  },
  {
    id: 'customFields',
    name: 'contacts.field_group.custom_fields',
    filter: (field: FormServFieldType) => !field.field_options?.fs_default,
  },
];

export type DefaultOptionType = { id: string; name: string };

export const defaultOptions = [
  {
    id: 'survey' as const,
    name: 'contacts.import_contact.placeholder_headers.survey',
  },
  {
    id: 'contact' as const,
    name: 'contacts.import_contact.placeholder_headers.contact',
  },
  {
    id: 'list' as const,
    name: 'workflow.condition.condition_variable.list',
  },
  {
    id: 'segment' as const,
    name: 'workflow.condition.condition_variable.segment',
  },
  {
    id: 'import_survey' as const,
    name: 'import_survey',
  },
  {
    id: 'import' as const,
    name: 'contacts.import_contact.heading',
  },
];
